/**
 * Marketing site shared constants — social URLs, App Store link, taglines.
 *
 * Centralised here so every page imports from one place. Update once when a
 * new social channel launches or the app moves stores.
 */

export const SOCIAL = {
  appStore: "https://apps.apple.com/us/app/sister-signal/id6769918475",
  linkedin: "https://www.linkedin.com/company/sister-signal/",
  tiktok: "https://www.tiktok.com/@sistersignal",
  facebook: "https://www.facebook.com/share/1GxDRPCKrU/?mibextid=wwXIfr",
  instagram: "https://www.instagram.com/sistersignalapp",
  threads: "https://www.threads.com/@sistersignalapp",
};

export const TAGLINES = {
  primary: "Clarity is protection.",
  secondary: "Emotional safety. Relationship clarity. Empowered choices.",
};

export const PRESS_CONTACT_EMAIL = "press@sistersignal.org";
export const PARTNERS_CONTACT_EMAIL = "partners@sistersignal.org";
export const GENERAL_CONTACT_EMAIL = "hello@sistersignal.org";

/** Hero logo asset hosted on Emergent CDN (provided by user). */
export const HERO_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_safe-circle-13/artifacts/oqs5kpar_E93D563A-4E0B-4A2F-B15E-586C6BD01EED.PNG";

/** Founder headshot — used in About.jsx "Meet the Founder" section. */
export const FOUNDER_HEADSHOT_URL =
  "https://customer-assets.emergentagent.com/job_safe-circle-13/artifacts/b4gbbdw1_40BE96D4-5D90-4B5E-899C-A0D0C330D146.PNG";

/** Lifestyle "app in hands" marketing photo — available for hero / press kits. */
export const LIFESTYLE_PHONE_URL =
  "https://customer-assets.emergentagent.com/job_safe-circle-13/artifacts/djj1b849_6292D4EE-119D-42A7-88D1-9FECA26AA72D.PNG";

/** Featured press coverage — drives the homepage "Featured In" badge AND the
    Press page cards. Update headlines/URLs here in one place. */
export const FEATURED_PRESS = [
  {
    outlet: "Des Moines Register",
    kind: "Article",
    headline: "Des Moines woman creates app for domestic abuse survivors",
    url: "https://www.desmoinesregister.com/story/news/local/des-moines/2026/06/15/sister-signal-app-domestic-violence-iowa/90104073007/",
    description: "Sister Signal founder Sara Love shares the story behind creating a survivor-informed safety and support platform for women navigating abuse and coercive control.",
  },
  {
    outlet: "Des Moines Register",
    kind: "Video Interview",
    headline: "Sara Love discusses the inspiration behind Sister Signal",
    url: "https://www.desmoinesregister.com/videos/news/local/des-moines/2026/06/15/sister-signal-app-sara-love-des-moines/90475735007/",
    description: "A video interview featuring Sara Love discussing the mission behind Sister Signal and the need for accessible support tools for survivors.",
  },
];
